import { pathBuilder } from 'config/paths/index';

export const root = '/admin/company/custom_fields';
export default pathBuilder(root);
